import React from "react";
import { Button, Tooltip, Text } from "@showitinc/showit-wc";

import {
  canSelectedGroupDissolve,
  canRemoveFromGroup,
  canSelectionGroup,
  canSelectionJoinGroup,
  groupSelection,
  dissolveSelection,
  removeSelectionFromGroup,
  addSelectionToGroup,
} from "@/utils/GroupUtils";
import uiPrefix from "@/utils/UiPrefixUtils";

import styles from "../ElementToolbar.module.css";

const GroupToolbarButtons = ({ selectedBlock, selectedElementsData, selectedElements, zoom }) => {
  const canRemove = canRemoveFromGroup(selectedElements);
  const canDissolve = canSelectedGroupDissolve(selectedElements);
  const canGroup = canSelectionGroup(selectedElements);
  const canJoinGroup = canSelectionJoinGroup(selectedElements);

  return (
    <>
      {canGroup && (
        <Tooltip
          key={"groupSelectionButton"}
          delay={10}
          position="top-center"
          positionType="absolute"
        >
          <Button
            variant="icon"
            data-e2e={uiPrefix("group-selection-button")}
            className={styles.button}
            onClick={() => groupSelection(selectedElements, selectedBlock)}
            iconPrefix="group"
            iconSize="20"
          />
          <span slot="content">
            <Text className={styles.label}>Group Elements</Text>
          </span>
        </Tooltip>
      )}
      {canDissolve && (
        <Tooltip
          key={"dissolveGroupButton"}
          delay={10}
          position="top-center"
          positionType="absolute"
        >
          <Button
            variant="icon"
            data-e2e={uiPrefix("dissolve-group-button")}
            className={styles.button}
            onClick={() => dissolveSelection(selectedElements, selectedBlock)}
            iconPrefix="unGroup"
            iconSize="20"
          />
          <span slot="content">
            <Text className={styles.label}>Ungroup</Text>
          </span>
        </Tooltip>
      )}
      {canRemove && (
        <Tooltip
          key={"removeFromGroupButton"}
          delay={10}
          position="top-center"
          positionType="absolute"
        >
          <Button
            variant="icon"
            data-e2e={uiPrefix("remove-from-group-button")}
            className={styles.button}
            onClick={() => removeSelectionFromGroup(selectedElements, selectedBlock)}
            iconPrefix="removeFromGroup"
            iconSize="20"
          />
          <span slot="content">
            <Text className={styles.label}>Remove from group</Text>
          </span>
        </Tooltip>
      )}
      {canJoinGroup && (
        <Tooltip key={"addToGroupButton"} delay={10} position="top-center" positionType="absolute">
          <Button
            variant="icon"
            data-e2e={uiPrefix("add-to-group-button")}
            className={styles.button}
            onClick={() => addSelectionToGroup(selectedElements, selectedBlock)}
            iconPrefix="addToGroup"
            iconSize="20"
          />
          <span slot="content">
            <Text className={styles.label}>Add to group</Text>
          </span>
        </Tooltip>
      )}
    </>
  );
};

export default GroupToolbarButtons;
